import React from 'react';
import { message, Modal } from 'antd';

import { ApiError } from '../services/api';
import { logger } from '../services/logger';

// The toolbar has z-index:9999 (_mdl-main.scss). antd messages default to z-index≈1010 (zIndexPopupBase+10),
// which puts them behind the toolbar. Mounting messages in their own fixed stacking context at z-index:10001
// makes them appear above the toolbar without changing zIndexPopupBase for all other antd overlays
// (Drawers, dropdowns) that need to stay below the toolbar so the profile menu covers them.
let _msgContainer: HTMLElement | undefined;

function getMessageContainer(): HTMLElement {
  if (!_msgContainer) {
    _msgContainer = document.createElement('div');
    _msgContainer.style.cssText =
      'position: fixed; top: 0; left: 0; width: 100%; z-index: 10001; pointer-events: none;';
    document.body.appendChild(_msgContainer);
  }

  return _msgContainer;
}

message.config({ getContainer: getMessageContainer });

class Notify {
  success(msg: string | React.ReactElement) {
    message.success(msg);
  }

  error(
    msg: string | React.ReactElement,
    error?: unknown,
    context?: { [key: string]: any },
  ) {
    let logMessage = msg;

    if (context?.message) {
      logMessage = context.message;
      delete context.message;
    }

    if (error instanceof ApiError && error.userMessage) {
      msg += `: ${error.userMessage}`;
    }

    message.error(msg, 8);

    logger.error(String(logMessage), {
      ...context,
      error,
    });
  }

  alert({
    title,
    content,
    okText,
    type = 'warning',
  }: {
    title: string | React.ReactElement;
    content?: string | React.ReactElement;
    okText?: string | React.ReactElement;
    type?: 'warning' | 'info' | 'error' | 'success';
  }): Promise<void> {
    return new Promise<void>((resolve) => {
      Modal[type]({
        title,
        content,
        okText,
        onOk: () => resolve(),
      });
    });
  }

  confirm({
    title,
    content,
    okText,
  }: {
    title: string | React.ReactElement;
    content?: string | React.ReactElement;
    okText?: string | React.ReactElement;
  }): Promise<boolean> {
    return new Promise((resolve) => {
      Modal.confirm({
        title,
        content,
        okText,
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  }
}

export const notify = new Notify();
